/**
 * Separated from liferay.ts because liferay.ts configures the AMD environment and therefore I cannot import
 * modules until requirejs.config finishes.  My moving it into a separate module that loads in a properly configured
 * AMD environemnt I'm able to get type-safety.
 */
import App = require("./app");
import $ = require("jquery");
import Utils = require("./utils");
import Defaults = require("./models/defaults");
import Portal = require("portal-gis");

const constants = {
    MarkerIndex: "_MARKER_INDEX_",
    ModelClicked: "model:clicked"
}

type Handle = { off: () => void };
interface Radio {
    trigger(name: string, args: any);
    on(name: string, cb: Function);
}

class Runner {

    static about = `
Used by [liferay loader](#liferay) to initialize the maplet.
    `;

    static run(options: {
        config: Portal.MapApplicationElement;
        view: {
            options: {
                config: {
                    mapConfig: string;
                    collection: Backbone.Collection<any>;
                    channel: Radio;
                }
            };
            $el: JQuery;
        }
    }) {
        //$("body").addClass("rhythm-civics");
        let view = options.view;
        let viewConfig = view.options.config;
        let selectedLayers = options.selectedLayers;
        let config = options.config || { parentId: viewConfig.mapConfig };

        return App.create(config).done(app => {

            let radio = viewConfig.channel;
            // provides the maplet with a mechanism for communicating with this view 
            app.mediator.model.set("civics-channel", radio);
            let layersList = selectedLayers;
            /**
             * Hack to identify the target region, probably put this in the options instead?
             * e.g. {view: view, region: "put-map-here" } 
             */
             // the view can already be destroyed before it is done initialized, need a null check here
             if ( view.$el.parent().length>0 ){
               app.controller.config["region"] = view.$el[0].parentNode["className"];
             }

            radio.on("map:destroy", () => {
                // console.log("destroy map view");
                app.destroy();
            });

        });

    }
}

export = Runner;